<template>
  <main class="contact" id="contact">
      <div class="infoCont" id="meshMe">

        <div class="subCont pdf" id="pTop">
          <img src="../assets/icons/pdf.png" alt="pdf icon">
          <div>
            <p>
              I have prepared a summary of all the information I show here in one single document, where you will have my professional profile 
              and direct contact information.
            </p>

            <a class="cv" :style="{ cursor: 'pointer' }" ref="showOptions" @click="cvOptions()">Download my CV as PDF</a>

            <div ref="cvOptions" :style="{ display: 'none' }">
              <a class="cv" href="/docs/cv/nethanzels_cv.pdf" target="_blank">Download in english</a>
              <a class="cv" href="/docs/cv/nethanzels_cv_sp.pdf" target="_blank">Descargar en español</a>
            </div>
          </div>
        </div>

        <div class="subCont socialContact">
          <section class="message">
            <h3>Leave a message right here:</h3>
            <div id="contactForm">
              <input 
                type="text" 
                id="clName" 
                class="input" 
                placeholder="Your name" 
              />
              
              <input
                type="text"
                id="clContact"
                class="input"
                placeholder="A way to contact you back"
              />

              <textarea
                id="clMessage"
                cols="30"
                rows="30"
                class="input"
                placeholder="Your message"
              />

              <div class="btnParent" ref="btnParent">
                <span class="btn" @click="sendMessage()">Send</span>
              </div>
            </div>

            <img src="../assets/spinb.png" class="spin" ref="spin" />

            <p id="advise"></p>
          </section>

          <section class="media">

            <div class="head">
              <h3>Catch me on social media:</h3>
            </div>

            <div class="buttons">
              <a href="https://t.me/nethanzel" target="_blank">
                <div class="social_btn">
                  <div class="icon-holder">
                    <div class="icon">
                      <i class="icofont-telegram"></i>
                    </div>
                    <span> Telegram </span>
                  </div>
                </div>
              </a>

              <a href="https://facebook.com/natanaelabaad" target="_blank">
                <div class="social_btn">
                  <div class="icon-holder">
                    <div class="icon">
                      <i class="icofont-facebook"></i>
                    </div>
                    <span>Facebook </span>
                  </div>
                </div>
              </a>

              <a href="https://www.linkedin.com/in/natanael-abad-136404176" target="_blank">
                <div class="social_btn">
                  <div class="icon-holder">
                    <div class="icon">
                      <i class="icofont-linkedin"></i>
                    </div>
                    <span>Linkedin </span>
                  </div>
                </div>
              </a>

              <a href="https://www.instagram.com/nethanz_l" target="_blank">
                <div class="social_btn">
                  <div class="icon-holder">
                    <div class="icon">
                      <i class="icofont-instagram"></i>
                    </div>
                    <span>Instagram </span>
                  </div>
                </div>
              </a>
            </div>
            
          </section>
        </div>

      </div>
  </main>
</template>

<script>
import Request from "../mixins/axiosRequest";
import queryPalette from "../mixins/themeColor.js";

export default {
  name: "Contact",
  title: "Get in touch - Nethanzêl's Showroom",

  data() {
    return {
    }
  },

  methods: {
    async sendMessage() {
      let sender = document.getElementById("clName"),
        contact = document.getElementById("clContact"),
        message = document.getElementById("clMessage"),
        spin = this.$refs.spin,
        btnParent = this.$refs.btnParent;

      spin.style.display = "inline";
      btnParent.style.display = "none";

      let nMessage = {
        sender: sender.value,
        contact: contact.value,
        message: message.value
      };

      let res = await Request.axiosPost("/api/message", nMessage, this.client);
      let advise = document.getElementById("advise");
      advise.style.display = "inline-flex";

      if(res.status && res.code == 204) {
        document.getElementById("contactForm").style.display = "none";
        advise.innerText = "Your message was sent.";
      } else {
        document.getElementById("contactForm").style.display = "none";
        advise.innerText = "Your message couldn't be sent, try again later.";
      }
      spin.style.display = "none";
    },
    cvOptions() {
      this.$refs.showOptions.style.display = "none";
      this.$refs.cvOptions.style.display = "flex";

      setTimeout(() => {
        this.$refs.showOptions.style.display = "block";
        this.$refs.cvOptions.style.display = "none";
      }, 10000)
    }
  },

  mounted() {
    queryPalette.generatePalette().then((Palette) => {
      document.querySelector("#meshMe").style.backgroundImage = `radial-gradient(at 85% 15%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
      document.querySelector("#meshMe").style.backgroundImage += `,radial-gradient(at 20% 80%, ${Palette[0][Math.floor(Palette.length / 2)]}75 0, transparent 50%)`;
      document.querySelector("#meshMe").style.backgroundImage += `,radial-gradient(at 50% 50%, ${Palette[1][Math.floor(Palette.length / 2)]}85 0, transparent 70%)`;
    });
  }

};
</script>

<style scoped lang="scss">

@media (prefers-color-scheme: light) {
  .infoCont {
    background-color: #d1d1d1;
  }

  .subCont {
    background-color: #ffffff44;
  }
}

@media (prefers-color-scheme: dark) {
  .infoCont {
    background-color: #fff;
  }

  .subCont {
    background-color: #00000044;
  }

}

.pdf {
  display: flex;
  align-items: center;

  img {
    height: 150px;
    margin: 0 35px 0 25px;
  }

  div {
    text-align: left;
    display: flex;
    flex-direction: column;

    p {
      text-align: justify;
      margin-right: 35px;
    }

    a {
      margin: 0 auto 10px auto;
    }
  }
}

.infoCont {
  width: 60%;
  height: auto;
  transition: .4s;
  padding: 40px 30px;
  margin: 5px 0 30px 0;

  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;

  overflow: hidden;
  z-index: 10;

  .subCont {
    padding: 10px;
    box-shadow: 0px 0px 5px #000000ab;
    -webkit-backdrop-filter: blur(6.2px);
    backdrop-filter: blur(6.2px);
    transition: background-color .4s;
  }
}

.infoCont .socialContact {
  display: grid;
  grid-template-rows: 1;
  grid-template-columns: 4;
  grid-template-areas: 'mes mes mes med';
  padding: 0;

  .media {
    background-color: rgba(0, 0, 0, .8);
    grid-area: med;
    display: flex;
    flex-direction: column;
    padding: 10px;

    .head {
      margin: 0 0 15px 0;
      h3 {
        color: #fff;
        padding: 10px 5px;
        margin: 0 30px;
      }
    }

    .buttons {
      text-align: center;
      padding-left: 5px;
    }

  }

  .message {
    grid-area: mes;
    min-height: 150px;
    padding: 20px 10px;
  }
}

.infoCont .subCont:nth-child(n+2) {
  margin-top: 30px;
}

.infoCont h1 {
  font-size: 40px;
  color: #000;
}

.infoCont p {
  margin-top: 25px;
}

.infoCont p,
h3 {
  text-align: center;
  color: #000;
  cursor: default;
}

h3 {
  margin-bottom: 10px;
}

.cv {
  text-decoration: none;
  color: #fff;
  background: #000;
  padding: 1px 7px;
  font-weight: bold;
  margin: 0 10px;
}

.contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 1366px;
  min-height: 80vh;
  padding: 75px 0 0 0;
  margin: 0px auto 0 auto;
}

h1 {
  cursor: default;
  color: #000;
}

h1::after {
  content: "";
  display: block;
  margin: 0 auto;
  width: 220px;
  border-bottom: 2px solid #000;
  margin-top: 5px;
}

p {
  text-align: justify;
  margin-bottom: 15px;
  line-height: 22px;
  cursor: default;
}

#telImg {
  height: 35px;
  width: 35px;
}

.input {
  display: block;
  outline: none;
  border: none;
  margin: 10px 0;
  padding: 7px 10px;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.50);
  font-size: 16px;
  opacity: 0.4;
  transition: 0.2s;
  min-width: 375px;
}

.input:hover {
  opacity: 0.7;
  display: block;
  outline: none;
}

#contactForm input:focus {
  opacity: 1;
  border: 1px solid rgba(108, 108, 108, 0.5);
  border-bottom: 3px solid;
}

textarea {
  resize: none;
  height: 85px;
  transition: 0.2s;
  min-width: 375px;
  color: #fff;
}

textarea:hover {
  opacity: 0.7;
}

#contactForm textarea:focus {
  opacity: 1;
  border: 1px solid rgba(108, 108, 108, 0.5);
  border-bottom: 3px solid;

}

#contactForm {
  display: flex;
  flex-direction: column;
  padding: 0 30px;
  transition: all 0.5s;
}

.btnParent {
  padding: 10px;
}

.social_btn {
  display: inline-flex;
  justify-content: center;
  cursor: pointer;
  width: 120px;
  margin: 10px 15px;
  padding: 6px 3px 3px 3px;
  background: #fff;
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
  border: #000 1px solid;

  span {
    background: transparent;
    color: #000;
    padding: 7px 5px;
    font-size: 14px;
  }
}

.icon-holder {
  display: flex;
  align-items: center;
}

.icon i {
  font-size: 1.65em;
  color: #000;
}

.btn {
  border: 1px solid #000;
  transition: 0.6s;
  padding: 5px 30px;
  color: #000;
}

.btn:hover {
  padding: 5px 30px;
  background: #000;
  color: #fff;
  cursor: pointer;
}

#advise {
  padding: 5px 30px;
  margin: 30px;
  background: #000;
  color: #fff;
  display: none;
  width: auto;
}

.spin {
  display: none;
  height: 30px;
  animation: 2s rotate360 infinite linear;
}

@keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes rotate360 {
  to {
    transform: rotate(360deg);
  }
}

@media screen and (max-width: 1100px) {
  .infoCont .socialContact {
    grid-template-rows: 2;
    grid-template-columns: 2;
    grid-template-areas: 'med med'
                         'mes mes';

    .media {
      grid-area: med;
      min-height: 200px;
      padding-top: 20px;
      h3 {
        padding: 10px 5px;
        margin: 0 30px;
      }
    }
    .message {
      grid-area: mes;
    }
  }
}

@media screen and (max-width: 800px) {
  .contact {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0px auto 0 auto;
    padding-top: 0;
  }

  .infoCont {
    width: 85%;
    height: auto;
    padding: 20px 20px;
  }

  #contactForm {
    display: flex;
    flex-direction: column;
    padding: 0 15px;
  }

}

@media screen and (max-width: 680px) {
  .pdf {
    display: block;
    div {
      p {
        text-align: justify;
        margin: 10px;
      }
    }
  }

  #contactForm {
    padding: 0;
  }

  .infoCont {
    padding: 5px;
  }

  .input {
    min-width: 0px;
  }
}

@media screen and (max-width: 450px) {
  #contactForm {
    display: flex;
    flex-direction: column;
  }

  .btnTelegram {
    width: 115px;
    margin: 0 5px;
    padding: 3px 3px;
  }

  .btnTelegram span {
    font-size: 14px;
    background: transparent;
    color: #fff;
    padding: 7px 3px;
  }

  #telImg {
    height: 30px;
    width: 30px;
  }

  .infoCont {
    width: 100%;
    padding: 0;
  }


  .message {
    padding-bottom: 15px;
  }
}
</style>
